import { Icon } from '@chakra-ui/react';

export const CustomNavArrowIcon = ({ fill, ...props }) => (
  <Icon viewBox="0 0 12 12" {...props}>
    <path
      className={fill ? undefined : 'sideNavChevron'}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4656 1.76696L1.23098 11L0.5 10.2691L9.73462 1.03432H2.79465V0H11.5V8.70553H10.4656V1.76696Z"
      fill={fill ?? '#FFFFFF'}
    />
  </Icon>
);

export default CustomNavArrowIcon;
